import { ReactNode, createContext, useContext, useState } from 'react';

import { NpsSurveyContextType, NpsSurveyFormValues } from './npsSurveyProvider.types';

export const NpsSurveyContext = createContext<NpsSurveyContextType>({} as NpsSurveyContextType);

type Props = {
  children: ReactNode;
};

export const useNpsSurveyContext = () => useContext(NpsSurveyContext);

export const NpsSurveyProvider = ({ children }: Props) => {
  const [npsSurveyFormValues, setNpsSurveyFormValues] = useState<NpsSurveyFormValues>({
    npsScore: null,
    scoreComment: '',
    influence: null,
    influenceComment: '',
  });

  const updateNpsValue = (updatedValue: Partial<NpsSurveyFormValues>) => {
    setNpsSurveyFormValues((state) => ({ ...state, ...updatedValue }));
  };

  const contextValue: NpsSurveyContextType = {
    npsSurveyFormValues,
    updateNpsValue,
  };

  return <NpsSurveyContext.Provider value={contextValue}>{children}</NpsSurveyContext.Provider>;
};
